<div class="message-modal">
    <img alt="" aria-hidden="true" class="header-image" src="/assets/images/illustration-15.svg">
    <h1 class="title" i18n="@@employment.popup.contactShared.title" id="modal-title">Kontaktdaten geteilt</h1>
    <p class="body" i18n="@@employment.popup.contactShared.content">Wir raten Ihnen, beim ersten Treffen eine
        Vertrauensperson dabei zu haben. Die Checkliste hilft Ihnen bei der Vorbereitung des Gespräches.</p>
    <div class="action">
        <button (click)="ok()" class="button" i18n="@@employment.popup.contactShared.btnOk">Alles klar</button>
        <a class="button primary"
           href="https://www.clea.app/informationen-assistenznehmende/"
           i18n="@@employment.popup.contactShared.linkCheckList"
           i18n-href="@@www-clea-app-informationen-assistenznehmende"
           target="_blank"
        >Checkliste</a>
    </div>
</div>
